import { IAvisEditableListFieldArrayProps } from "../../../types";
import { AvisEditableListFooterRow } from "./";

export function AvisEditableListFooter<T extends object, P extends object>(
  props: Readonly<IAvisEditableListFieldArrayProps<T, P>>,
) {
  return (
    <thead>
      <AvisEditableListFooterRow {...props} />
    </thead>
  );
}
